import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import ui from './ui'
import user from './user'
import game from './game'

const store = new Vuex.Store({
	modules: {
		ui,
		user,
		game,
	},
	actions: {
		async init({ dispatch, commit, state, getters }) {
			await dispatch('user/init')
			await dispatch('game/init')
			dispatch('ui/init')
		}
	}
})

export default store
